import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  changeServiceArgs,
  sendRequest
} from 'mt-react-common/modules/events/common/reducers/userNoticesSetReadForm';

const userNoticesSetReadFormRN = 'eventsModule.forms.userNoticesSetReadForm';

class NoticeSetReadAllButton extends Component {
  handleSetRead = e => {
    e.preventDefault();
    this.props.changeServiceArgs(['all']);
    this.props.sendRequest();
  };

  render() {
    return (
      <a href="" onClick={this.handleSetRead}>
        {t('Отметить все как прочитанное')}
      </a>
    );
  }
}

NoticeSetReadAllButton.propTypes = {
  changeServiceArgs: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  changeServiceArgs: args =>
    dispatch(changeServiceArgs(userNoticesSetReadFormRN, args)),
  sendRequest: () => dispatch(sendRequest(userNoticesSetReadFormRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoticeSetReadAllButton);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/ActionsButtons/NoticeSetReadAllButton.js